// Plugin para sistema de notificações customizado
import Vue from 'vue'
import CustomNotification from '@/components/ui/CustomNotification.vue'

// Criar uma instância global do componente de notificação
const NotificationConstructor = Vue.extend(CustomNotification)

let notificationInstance = null

// Função para garantir que existe uma instância
function getNotificationInstance() {
  if (!notificationInstance) {
    notificationInstance = new NotificationConstructor()
    notificationInstance.$mount()
    document.body.appendChild(notificationInstance.$el)
  }
  return notificationInstance
}

// Objeto com os métodos de notificação
const CustomNotify = {
  success(message, duration = 4000) {
    const instance = getNotificationInstance()
    return instance.showSuccess(message, duration)
  },
  
  error(message, duration = 6000) {
    const instance = getNotificationInstance()
    return instance.showError(message, duration)
  },
  
  warning(message, duration = 5000) {
    const instance = getNotificationInstance()
    return instance.showWarning(message, duration)
  },
  
  info(message, duration = 4000) {
    const instance = getNotificationInstance()
    return instance.showInfo(message, duration)
  },
  
  clear() {
    if (notificationInstance) {
      notificationInstance.clear()
    }
  },
  
  // Método genérico
  show(message, type = 'info', duration = 4000) {
    const instance = getNotificationInstance()
    return instance.addNotification(message, type, duration)
  }
}

// Plugin para instalar no Vue
const NotificationPlugin = {
  install(Vue) {
    // Adiciona as funções ao prototype do Vue
    Vue.prototype.$notify = CustomNotify
    
    // Também adiciona como propriedade global
    Vue.notify = CustomNotify
  }
}

export default NotificationPlugin